import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ProcessParticipationAnswer } from '../../../models/process-models';
import { SurveyInfrastructure, QuestionType } from '../../../models/questions';

@Component({
  selector: 'app-user-question-form-selector',
  templateUrl: './user-question-form-selector.component.html',
  styles: []
})
export class UserQuestionFormSelectorComponent implements OnInit{
  @Input() question: SurveyInfrastructure;
  @Input() answers: Array<ProcessParticipationAnswer>;
  @Output() questionAnswered = new EventEmitter<SurveyInfrastructure>();
  questionWithOrderedAnswers: SurveyInfrastructure;
  questionType: any = QuestionType;

  constructor() { }

  ngOnInit(): void {
    this.questionWithOrderedAnswers = {...this.question, answers: this.question.answers.sort((a, b) => a.order-b.order)};
  }

  onQuestionAnswered(question: SurveyInfrastructure): void {
    this.questionAnswered.emit(question);
 }

}
